module.exports = __webpack_public_path__ + "static/media/25.f93c726f.mp3";